<template>
  <div class="employees-page">
    <div class="page-header">
      <h1>Pracownicy</h1>
      <button
          v-if="appStore.isSubscribed"
          class="btn-primary"
          @click="$router.push('/dla-biznesu/profile/employees/add')"
      >
        + Dodaj pracownika
      </button>
    </div>

    <div class="section-card" v-if="currentUser && employees.length > 0">
      <div class="section-card-header">
        <h2>Lista pracowników</h2>
      </div>

      <div class="table-wrap">
        <table class="employees-table">
          <thead>
          <tr>
            <th>Imię</th>
            <th>Nazwisko</th>
            <th>Numer telefonu</th>
            <th>E-mail</th>
            <th>Akcje</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="employee in employees" :key="employee.id">
            <td>{{ employee.firstname }}</td>
            <td>{{ employee.lastname }}</td>
            <td>{{ employee.phone }}</td>
            <td>{{ employee.email }}</td>
            <td class="action-col">
              <button class="btn-icon btn-danger" @click="() => deleteEmployee(employee.id)" title="Usuń">
                <img src="@/assets/icons/trash.svg" alt="usuń">
              </button>
              <button class="btn-icon" @click="() => $router.push(`/browse/user/${employee.id}`)" title="Podgląd">
                <img src="@/assets/icons/eye-fill.svg" alt="zobacz">
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="load-more" v-if="employees.length > 10">
        <button
            class="btn-outline"
            @click="() => {
            employeesLimit += 5
            getEmployees(employeesLimit)
          }"
        >
          Załaduj więcej...
        </button>
      </div>
    </div>

    <div v-else class="section-card">
      <div class="empty-state">
        <p>Brak pracowników.</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { useMeta } from 'vue-meta';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'BizProfileEmployees',
  setup() {
    useMeta({ title: 'Pracownicy' });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      employees: [],
      employeesLimit: 10,
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 2) {
      this.$router.push('/login');
    }
    this.getEmployees(this.employeesLimit);
  },
  methods: {
    getEmployees(limit) {
      axios.post(`/Users`, { main_id: this.currentUser.id, page: 1, limit: limit }, authHeader())
          .then(res => {
            this.employees = res.data.items;
          });
    },
    deleteEmployee(id) {
      axios.delete(`/User/${id}`, authHeader()).then(res => {
        if (String(res.status).charAt(0) == '2') {
          this.appStore.setIsSuccess('Pomyślnie usunięto pracownika');
          this.getEmployees(this.employeesLimit);
        }
      });
    },
  },
};
</script>

<style scoped lang='scss'>
.employees-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  color: #1f2937;
  font-weight: 700;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0,0,0,.08);
  padding: 24px;
  box-sizing: border-box;
}

.section-card-header h2 {
  margin: 0 0 12px;
  font-size: 2rem;
  color: #1f2937;
}

.table-wrap {
  width: 100%;
  overflow-x: auto;
}

.employees-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 760px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}

.employees-table thead th {
  background: #f9fafb;
  color: #374151;
  font-size: 1.4rem;
  font-weight: 700;
  text-align: left;
  padding: 12px;
  border-bottom: 1px solid #e5e7eb;
}

.employees-table tbody td {
  padding: 12px;
  font-size: 1.4rem;
  color: #1f2937;
  border-bottom: 1px solid #f1f5f9;
}

.employees-table tbody tr:last-child td {
  border-bottom: none;
}

.employees-table tbody tr:hover td {
  background: #fcfcfd;
}

.action-col {
  display: flex;
  align-items: center;
  gap: 6px;
}

.load-more {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

.btn-primary {
  background: #f97316;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
}
.btn-primary:hover { background: #ea6c0a; }

.btn-outline {
  background: #fff;
  color: #1f2937;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 14px;
  cursor: pointer;
  font-size: 1.4rem;
}
.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  transition: background-color 0.2s;
}
.btn-icon img {
  width: 20px;
  height: 20px;
}
.btn-icon:hover {
  background: #f3f4f6;
}
.btn-danger:hover {
  background: #fee2e2;
}

.empty-state {
  text-align: center;
  color: #9ca3af;
  font-size: 1.5rem;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
  padding: 24px;
}

@media (max-width: 480px) {
  .employees-page {
    padding: 16px 12px;
  }
  .page-header h1 {
    font-size: 2.2rem;
  }
  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }
  .btn-primary,
  .btn-outline {
    width: 100%;
    text-align: center;
  }
}
</style>